import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';

// -----
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
// -----


// Components & Utils
import ShadowBackgroundTextBanner from '../components/faq/ShadowBackgroundTextBanner';
import { UIContext } from '../providers/UIProvider';

// UI
import { Button, Stack, Typography, useTheme, Box } from '@mui/material';
import useDocumentTitle from '../hooks/useDocumentTitle';

let token = null;

function ConfirmationDialogRaw(props) {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current !== null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };



  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle>Confirmar eliminar cuenta</DialogTitle>
      <DialogActions>
        <Button
          type='submit'
          aria-label='Confirmar'
          variant='contained'
          color='error'
          size='large'
          onClick={handleCancel}
        >
          Cancelar
        </Button>
        <Button
          type='submit'
          aria-label='Confirmar'
          variant='contained'
          color='success'
          size='large'
          onClick={handleOk}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};

/**
 * @function Unsubscribe
 * @author RCH010
 * @version 1.0
 * @description a description of the component
 * @param {String} something short description of prop
 * @returns {JSX}
 */
const DeleteAccount = () => {
  useDocumentTitle('Oasis App - Eliminar cuenta');
  const theme = useTheme();
  const { setNavbarBackgroundColor, toggleSnackbar, updateSnackbarProps } =
    useContext(UIContext);
  const [isLoading, setIsLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  token =  params.token;

  const {
    handleSubmit,
  } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    setNavbarBackgroundColor(theme.palette.lightBackground);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpen] = React.useState(false);
  const [deleteAccount, setDeleteAccount] = React.useState(true);

  const handleClickDeleteAccount = () => {
    setOpen(true);
  };

  const handleClose = async (newValue) => {
    setOpen(false);
    
    if (newValue === undefined) {
      return
    }
    toggleSnackbar(true);

    setIsLoading(true);
    setDeleteAccount(newValue);

    updateSnackbarProps({
      severity: 'info',
      text: 'Tu cuenta se esta eliminando...',
    });
    toggleSnackbar(true);

    // TODO: FETCH ALWAYS RETURNS RESOLVED
    fetch(`https://xpd6ryrlx1.execute-api.us-east-2.amazonaws.com/dev/api/account/confirm-delete?x_delete_token=${token}`, {
      method: 'POST',
    }).then((res)=>{
      console.log(res);
      if (res?.status === 200) {
        updateSnackbarProps({
          severity: 'success',
          text: 'Tu cuenta se ha eliminado correctamente.',
        });
        navigate('/');
      }else{
        console.log(error);
        updateSnackbarProps({
          severity: 'error',
          text: 'Ha ocurrido un error, por favor inténtelo más tarde.',
        });
      }
    }).catch((error)=>{
      console.log(error);
      updateSnackbarProps({
        severity: 'error',
        text: 'Ha ocurrido un error, por favor inténtelo más tarde.',
      });
    }).finally(()=>{
      toggleSnackbar(true);
      setIsLoading(false);
    });
  };

  return (
    <Box
      sx={{
        bgcolor: (currTheme) => currTheme.palette.lightBackground,
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
      }}>
      <ShadowBackgroundTextBanner text={`Eliminar cuenta`} />
      <Box sx={{ bgcolor: (currTheme) => currTheme.palette.mainBackground }}>
        <Box
          sx={{
            pt: { xs: 15, md: 20 },
            pb: { xs: 20, md: 20 },
            maxWidth: 'md',
            px: 3,
            mx: 'auto',
            minHeight: '50vh',
          }}>
          <Typography variant='h1' sx={{ mb: 5 }}>
            ¿Estas segur@ de que quieres eliminar tu cuenta?
          </Typography>
          <Stack
            onSubmit={handleSubmit(handleClickDeleteAccount)}
            component='form'
            sx={{ maxWidth: { xs: '100%', md: '20em' }, mx: 'auto' }}
            spacing={5}>
            <Button
              type='submit'
              aria-label='Confirmar'
              variant='contained'
              color='error'
              size='large'
              disabled={isLoading}
            >
              Confirmar
            </Button>
          </Stack>
          <ConfirmationDialogRaw
            id="ringtone-menu"
            keepMounted
            open={open}
            onClose={handleClose}
            value={deleteAccount}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteAccount;
